type NamedUser = {
  user_id?: number | null;
  full_name?: string | null;
  user_name?: string | null;
} | null;

export type SystemMessageLike = {
  message_type?: string | null;
  message_content?: string | null;
  User?: NamedUser;
  ActionedUser?: NamedUser;
};

/**
 * Shared preview / bubble text for group system events.
 * Keeps chat list and message list in sync (e.g. "Name added Name to group").
 */
export function formatSystemMessageText(
  message: SystemMessageLike,
  opts: {
    currentUserId: number;
    translate: (key: string) => string;
    resolveName: (user: NamedUser) => string;
  },
): string {
  const { currentUserId, translate, resolveName } = opts;
  const name = (u: NamedUser) => {
    if (!u) return "";
    if (u.user_id == currentUserId) return translate("You");
    return resolveName(u) || u.full_name || u.user_name || "";
  };

  switch (message.message_type) {
    case "member-added":
      return `${name(message.User)} ${translate("added")} ${name(message.ActionedUser)} ${translate("to group")}`;
    case "member-removed":
      return `${name(message.User)} ${translate("removed")} ${name(message.ActionedUser)} ${translate("from group")}`;
    case "member-left":
      return `${name(message.User)} ${translate("left group")}`;
    case "promoted-as-admin":
      return `${name(message.ActionedUser)} ${translate("is now an admin")}`;
    case "removed-as-admin":
      return `${name(message.ActionedUser)} ${translate("is now an remove as admin")}`;
    case "group-created":
      return `${name(message.User)} ${translate("created group")}`;
    default:
      return message.message_content || "";
  }
}

export function isSystemMessageType(type?: string | null): boolean {
  return [
    "member-added",
    "member-removed",
    "member-left",
    "promoted-as-admin",
    "removed-as-admin",
    "group-created",
  ].includes(String(type || ""));
}
